module.exports = __webpack_public_path__ + "img/top-5-0.a9a7ae76.jpg";